import { render, staticRenderFns } from "./myCustomFields.vue?vue&type=template&id=432be732&scoped=true&"
import script from "./myCustomFields.vue?vue&type=script&lang=js&"
export * from "./myCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432be732",
  null
  
)

export default component.exports